<template>
  <v-container v-if="valPunto !== null" grid-list-xl>
    <div class="vue-contentido">
      <v-card :disabled="!puedegestionar" :loading="loading">
        <v-toolbar flat color="primary">
          <div class="text-white">
            {{ valPunto.codigo }} - {{ valPunto.nombre }}
          </div>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon x-large v-on="on" @click="SaveMetas">
                  <v-icon color="white">save</v-icon>
                </v-btn>
              </template>
              <span>Guardar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon x-large v-on="on" @click="FinalizarMetas">
                  <v-icon color="white">send</v-icon>
                </v-btn>
              </template>
              <span>Finalizar</span>
            </v-tooltip>
          </v-toolbar-items>
        </v-toolbar>
      </v-card>
      <v-divider></v-divider>

      <v-tabs
        show-arrows
        next-icon="fa-caret-right"
        prev-icon="fa-caret-left"
        icons-and-text
        background-color="blue-grey lighten-4"
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab>
          Metas
          <v-icon>mdi-file-alert</v-icon>
        </v-tab>
        <v-tab>
          Ficha Técnica
          <v-icon>dialpad</v-icon>
        </v-tab>
        <v-tab>
          Histórico
          <v-icon>history</v-icon>
        </v-tab>
        <v-tab-item>
          <v-form>
            <br />
            <v-card >
              <v-card :disabled="loading" :loading="loading">
                <v-layout row wrap>
                  <v-flex xs12 sm5 class="col-padd" >
                    <v-data-table
                      :headers="HeaderMetasVigencia"
                      :items="MetasVigencia"
                      class="elevation-1"
                      :no-data-text="gnodata"
                      :items-per-page="5"
                      :item-class= "row_classes" 
                    >
                      <template v-slot:top>
                        <v-dialog v-model="dialogMeta" max-width="300px">
                          <v-card>
                            <v-card-text>
                              <v-flex xs12 sm12 md12>
                                <v-text-field
                                  v-model="editedItemMeta.metaTmp"
                                  label="Meta"
                                  v-validate="'decimal:2'"
                                  data-vv-name="MetasVigencia"
                                  :disabled="readcontrol('valor')"
                                  :error-messages="
                                    errors.collect('MetasVigencia')
                                  "
                                ></v-text-field>
                              </v-flex>
                            </v-card-text>
                            <v-card-actions>
                              <v-btn color="blue darken-1" @click="close"
                                >Cancelar</v-btn
                              >
                              <v-btn
                                :disabled="readcontrol('valor')"
                                color="blue darken-1"
                                @click="saveMetaVigencia"
                                >Guardar</v-btn
                              >
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-on="on"
                              small
                              :disabled="!item.editable || MetaSoloLectura || !puedegestionar"
                              class="mr-2"
                              @click="editItemMetaVigencia(item)"
                              >edit</v-icon
                            >
                          </template>
                          <span>Editar</span>
                        </v-tooltip>
                      </template>
                      <template v-slot:[`item.metaTmp`]="{ item }">
                        <div v-if="item.valor !=  item.metaTmp">
                            {{ item.metaTmp }}
                        </div>
                      </template>                      
                    </v-data-table>
                  </v-flex>
                  <v-flex xs12 sm5 class="col-padd" >
                    <v-data-table
                      :headers="HeaderMetasCuatrenio"
                      :items="GetMetasCuatrenio"
                      class="elevation-1"
                      :no-data-text="gnodata"
                      :items-per-page="5"
                    ></v-data-table>
                  </v-flex>
                  <v-flex xs12 sm2 class="col-padd">
                    <v-text-field
                      readonly
                      v-model="valPunto.meta"
                      label="Meta global"
                      v-validate="'decimal:2'"
                      data-vv-name="Metas"
                      :error-messages="errors.collect('Metas')"
                      :disabled = "!puedegestionar"
                    ></v-text-field>
                    
                    <v-flex xs12 sm2 >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          
                          v-on="on"
                          block
                          color="blue-grey lighten-3"
                          @click="RefrescarMetas"
                          :disabled="readcontrol('reporte') || !puedegestionar"
                        >
                          <v-icon left>fa-calculator</v-icon>Generar metas
                          <span></span>
                        </v-btn>
                      </template>
                      <span>
                        Este botón calcula las metas de los periodos de gobierno y la meta global
                      </span>
                    </v-tooltip>
                    </v-flex>
                    
                    <v-flex xs12 sm2  v-show="showcontrol('recargar')">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          
                          v-on="on"
                          block
                          color="blue-grey lighten-3"
                          @click="recargarpagina"
                        >
                          <v-icon left>fa-sync-alt</v-icon>Recargar datos
                          <span></span>
                        </v-btn>
                      </template>
                      <span>
                        Este botón recarga la pagina
                      </span>
                    </v-tooltip>                    
                    </v-flex>


                    <v-alert dense text colored-border  elevation="2" border="left" color="info" :value="readcontrol('reporte')" >
                      <v-flex xs12 sm12>  
                        La función de generar metas se traslada al validador.
                      </v-flex>        
                    </v-alert>
                  </v-flex>
                  <v-flex xs12 sm6 class="col-padd">
                    <v-select
                      :readonly="true"
                      :disabled = "!puedegestionar"
                      :items="TAcumulacion"
                      v-model="valPunto.idtipoacumulacion"
                      item-text="nombre"
                      item-value="idtipoacumulacion"
                      label="Tipo acumulación *"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm6 class="col-padd"> </v-flex>
                </v-layout>
                <v-speed-dial
                  fixed
                  v-show="puedegestionar"
                  :bottom="true"
                  :right="true"
                  direction="left"
                  :open-on-hover="true"
                  transition="scale-transition"
                >
                  <template v-slot:activator>
                    <v-btn fab color="blue-grey lighten-3">
                      <v-icon>add</v-icon>
                    </v-btn>
                  </template>
                  <v-btn
                    id="btnp1"
                    fab
                    dark
                    small
                    color="green"
                    @click="FinalizarMetas"
                  >
                    <v-icon>send</v-icon>
                  </v-btn>
                  <v-btn fab dark small color="green" @click="SaveMetas">
                    <v-icon>save</v-icon>
                  </v-btn>
                </v-speed-dial>
              </v-card>
            </v-card>
          </v-form>
        </v-tab-item>
        <v-tab-item v-if="valPunto != null">
          <detalleindicador :getidIndicador="valPunto.idindicador" />
        </v-tab-item>
        <v-tab-item v-if="valPunto != null">
          <historico
            :idtabla="7"
            :idelemento="valPunto.idindicador"
          ></historico>
        </v-tab-item>
      </v-tabs>

      <v-divider></v-divider>

      <v-flex xs12 sm12 v-show="showcontrol('comentariometa')">
        <v-card tile :loading="loading">
          <v-toolbar flat dark color="primary">
            <v-toolbar-title
              >Revisión de las metas ({{ valPunto.codigo }})</v-toolbar-title
            >
            <div class="flex-grow-1"></div>
          </v-toolbar>
          <v-card-text>
            <v-flex xs12 sm12>
              <label for="revisioncomentario" class="form-label"
                >Comentario:</label
              >
              <quill-editor
                ref="revisioncomentario"
                id="revisioncomentario"
                data-vv-name="revisioncomentario"
                :error-messages="errors.collect('revisioncomentario')"
                v-model="valPunto.comentariometa"
                :disabled="!puedegestionar"
                :options="editorOptions"
                @ready="onEditorReady($event)"
                @change="onEditorChange($event)"
              />
              <div id="counter" class="counter"></div>
            </v-flex>
            <v-flex row>
              <v-flex xs6 sm6></v-flex>
              <v-flex xs6 sm6>
                <v-select
                  :items="dropdown_comment"
                  v-model="valPunto.metaaprobada"
                  item-text="text"
                  item-value="value"
                  label="Seleccione opción"
                  :disabled="!puedegestionar"
                ></v-select>
              </v-flex>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-snackbar
        v-model="snack"
        :timeout="timeoutsnak"
        :color="MesaggeInfo.color"
      >
        {{ this.MesaggeInfo.codigoRespuesta }}
        {{ this.MesaggeInfo.mensajeRespuesta }}
        <v-btn text @click="functionalert">{{ buttontext }}</v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import store from "../../stores/index.js";
import detalleindicador from "../../components/content/detalleindicador.vue";
import historico from "../../components/content/historico";
import { ErrorBag } from "vee-validate";
import "quill/dist/quill.core.css"; // import styles
import "quill/dist/quill.snow.css"; // for snow theme
import Counter from "../../components/global/counter.js";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";
var Delta = Quill.import("delta");
Quill.register("modules/counter", Counter);

export default {
  name: "reportemetas",
  data() {
    return {
      //campos default
      AvanceFiltrado: [],
      dataindicador: null,
      idindicador: null,
      valPunto: null,
      loading: false,
      puedegestionar: false,
      MetaSoloLectura: false,
      RolActual: [],

      HeaderMetasVigencia: [
        { text: "Año", value: "idperiodoNavigation.nombre", align: "center" },
        { text: "Meta", value: "valor", align: "center" },
        { text: "Ajuste a la Meta", value: "metaTmp", align: "center" },
        { text: "Acciones", value: "action", sortable: false },
      ],
      HeaderMetasCuatrenio: [
        {
          text: "Periodo",
          value: "idperiodoNavigation.nombre",
          align: "center",
        },
        { text: "Meta", value: "valor", align: "center" },
      ],
      EstadoActualMetas: 0,
      GetMetasCuatrenio: [],
      MetasVigencia: [],
      isrefreshmeta: false,
      estadocampos: [],
      dialogMeta: false,
      returpath: "",
      timeoutsnak: 4000,
      buttontext: "cerrar",
      TAcumulacion: [],
      editedIndexMeta: -1,
      editedIndexCuatrenio: -1,
      editedItemMeta: { valor: 0 },
      editedItemCuatrenio: { valor: 0 },
      defaultItemMeta: { valor: 0 },
      Editarmeta: true,
      snack: false,
      snackColor: "",
      snackText: "",
      MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],
      dropdown_comment: [
        { text: "Aprobar", value: true },
        { text: "Rechazar", value: false },
      ],

      dictionary: {
        custom: {
          MetasVigencia: {
            decimal: "solo numeros con el siguiente formato (.##) ",
          },
          Metas: {
            decimal: "solo numeros con el siguiente formato (.##) ",
          },
          revisioncomentario: {
            max: "está superando el límite de caracteres",
          },
        },
      },
      quill: null,
      editorOptions: {
        theme: "snow",
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ indent: "-1" }, { indent: "+1" }],
            ],
          },
          counter: {
            container: "#counter",
            controlContainer: "#revisioncomentario",
            unit: "letra",
            max: 8000,
          },
          clipboard: {
            matchers: [
              [
                Node.ELEMENT_NODE,
                function (node, delta) {
                  return delta.compose(
                    new Delta().retain(delta.length(), {
                      align: "justify",
                      link: false,
                      color: false,
                      size: "10px",
                      header: false,
                    })
                  );
                },
              ],
            ],
          },
        },
        placeholder: "",
      },
    };
  },
  components: {
    detalleindicador,
    historico,
    quillEditor,
  },
  $_veeValidate: {
    validator: "new",
  },
  created() {
    this.returpath = localStorage.pathfrom;
    this.get_usuarios();
    this.Gettipoacumulacion();
    let user = this.getusuario();
    let auten = user.token.replace("Bearer ", "");
    this.$aes.setKey(auten);
    let temporal = this.$route.params.idindicador.replace(/AbcYq/g, "/");
    temporal = temporal.replace(/qYcbA/g, "+");
    temporal = this.$aes.decrypt(temporal);
    temporal = temporal.substring(4);
    temporal = temporal.substring(0, temporal.length - 4);
    temporal = this.$aes.decrypt(temporal);
    //temporal = 135;
    this.idindicador = temporal;
    this.Indicador_Encabezado({
      params: {
        idindicador: temporal,
      },
    });

    if (user != undefined) {
      let iduser = user.idusuario;
      let Idrol = -1;

      if (user.usuarioRol.length > 0)
        user.usuarioRol.forEach((element) => {
          Idrol = element.idrol;
          this.RolActual.push(element.nombreRol.toUpperCase());
          this.get_verificargestionformulario({
            params: {
              Tabla: "META",
              idelemento: temporal,
              idusuario: iduser,
              idrol: Idrol,
            },
          });
        });
    }
    if (this.puedegestionar == false) this.puedegestionar = this.gtienegestion;
  },
  mounted() {
    this.$validator.localize("es", this.dictionary);
  },
  methods: {
    ...mapActions([
      "Indicador_Encabezado",
      "get_metasvigencia",
      "metascuatrenio",
      "GenerarMetas",
      "actualizarmetas",
      "Gettipoacumulacion",
      "get_camposestado",
      "estadometasnulas",
      "get_verificargestionformulario",
      "get_metastemporales"
    ]),
    ...mapActions("usuario/", ["get_usuarios"]),
    ...mapActions("fichatecnica/", [
      "set_permitenacional",
      "set_itemsclasificacion",
      "set_indicador",
    ]),
    onEditorReady(quill) {
      quill.format("align", "justify");
    },
    onEditorChange({ quill }) {
      quill.getModule("counter").update();
    },
    getusuario() {
      if (localStorage.usuario !== undefined) {
        return JSON.parse(unescape(localStorage.usuario));
      } else {
        return null;
      }
    },
    editItemMetaVigencia(item) {
      this.editedIndexMeta = this.MetasVigencia.indexOf(item);
      this.editedItemMeta = Object.assign({}, item);
      this.dialogMeta = true;
    },
    RefrescarMetas() {
      let groupmetas = [];
      groupmetas = this.MetasVigencia.concat(this.GetMetasCuatrenio);
      if (groupmetas.length > 0) {
        //store.dispatch("mensaje/set_reset");
        this.isrefreshmeta = true;
        this.loading = true;        
        this.valPunto.metaNavigation = groupmetas;
        this.GenerarMetas({
          data: this.valPunto,
        });
      }
    },
    recargarpagina() {
      let temporal = this.$route.params.idindicador.replace(/AbcYq/g, "/");
      let Currentpath = '/indicador/ediciondemetas/' + temporal;
      console.log('indicador', Currentpath)
      this.$router.go()
      //this.$router.push({name: 'EdicionMetas', params: { idindicador: temporal }}).catch(() => {})
      //this.$router.push({path: Currentpath});
      
    },
    SaveMetas() {
      // if (this.isrefreshmeta) {
      //   this.snack = true;
      //   this.MesaggeInfo.mensajeRespuesta =
      //     "Las metas vigencia fueron modificadas debe dar clic en el boton generar metas para actualizar las metas cuatrenio ";
      //   this.MesaggeInfo.color = "infovue";
      //   this.valPunto.finalizar = false;
      //   return;
      // } else {
        this.loading = true;
        let groupmetas = [];
        groupmetas = this.MetasVigencia.concat(this.GetMetasCuatrenio);
        this.valPunto.metaNavigation = groupmetas;

        if (this.EstadoActualMetas == 3 && this.valPunto.finalizar) {
          if (this.valPunto.metaaprobada == null) {
            this.snack = true;
            this.MesaggeInfo.mensajeRespuesta =
              "debe aprobar o rechazar las metas";
            this.MesaggeInfo.color = "infovue";
            this.loading = false;
            this.valPunto.finalizar = false;            
            return;
          }
          if (
            this.valPunto.comentariometa == null ||
            this.valPunto.comentariometa == ""
          ) {
            this.snack = true;
            this.MesaggeInfo.mensajeRespuesta =
              "El comentario de las  Metas no puede estar vacío";
            this.MesaggeInfo.color = "infovue";
            this.loading = false;
            return;
          }
        }
        this.actualizarmetas({
          data: this.valPunto,
        });
      // }
    },
    FinalizarMetas() {
      this.RolActual.forEach((dato) => {
        if (dato == 'DELEGADO')
        {
          this.FinalizarMetasPrevent();
        } else
        {
          let ConteoModificaciones =  this.MetasVigencia.filter(record => { return record.valor != record.metaTmp; }).length
          console.log('ConteoModificaciones', ConteoModificaciones)
          console.log('this.MetasVigencia', this.MetasVigencia)
          if (ConteoModificaciones > 0 && this.valPunto.metaaprobada == true ) {

            this.snack = true;
            this.MesaggeInfo.mensajeRespuesta = "Las metas gestionadas por el delegado se encuentran todavía en la tabla temporal, debe generar las metas antes de aprobar las metas.";
            this.MesaggeInfo.color = "warnvue";
          } else
          {
            this.FinalizarMetasPrevent();            
          }
        }
      })
    },
    FinalizarMetasPrevent()
    {
      this.ValidarRevisionComentario();
        this.$validator.validateAll().then((result) => {
          if (result && this.$validator.errors.items.length == 0) {
            this.valPunto.finalizar = true;                                    
            this.SaveMetas();
            this.marcarfinalizado();
            return;
          }
          ///este console lo vamos a dejar para ver los posibles error de validación
          console.log(this.$validator);
          this.snack = true;
          let Errores = "";
          this.$validator.errors.items.forEach((element) => {
            Errores = Errores + "( " + element.msg + " ), ";
          });
          this.MesaggeInfo.mensajeRespuesta =
            "la validación del formulario contiene errores " + Errores;
          this.MesaggeInfo.color = "infovue";
        });      
    },
    ValidarRevisionComentario() {
      let bag = new ErrorBag();
      bag = this.errors;
      if (bag.first("revisioncomentario") !== undefined)
        bag.removeById(bag.first("revisioncomentario").id);

      if (
        this.$refs.revisioncomentario.quill.root.innerHTML.length >
          this.$refs.revisioncomentario.quill.options.modules.counter.max &&
        bag.first("revisioncomentario") == undefined
      ) {
        bag.add({
          field: "revisioncomentario",
          msg: "está superando el límite de caracteres",
        });
      }
    },
    functionalert() {
      if (this.buttontext == "cerrar") {
        this.snack = false;
      }
      if (this.buttontext == "aceptar") {
        this.buttontext == "cerrar";
        this.snack = false;
        this.timeoutsnak = 4000;
        let ruta = this.returpath;
        if (ruta == "") {
          if (localStorage.pathfrom != "/") ruta = localStorage.pathfrom;
          ruta = "/tareas";
        }
        this.$router.push(ruta);
      }
    },
    close() {
      this.dialogMeta = false;
    },
    saveMetaVigencia() {
      if (this.editedIndexMeta > -1) {
        Object.assign(
          this.MetasVigencia[this.editedIndexMeta],
          this.editedItemMeta
        );
      }
      // this.isrefreshmeta = true;
      // this.MesaggeInfo.mensajeRespuesta =
      //   "La meta ha sido modificada; los cambios serán permanentes cuando guarde los cambios del indicador";
      // this.MesaggeInfo.color = "infovue";
      // this.snack = true;
      this.close();
    },
    readcontrol(control) {
      if (this.estadocampos != undefined)
        if (this.estadocampos.length > 0) {
          let responseread = this.estadocampos.find(function (element) {
            if (element.nombre == control) {
              return element;
            }
          });
          if (responseread == null) return true;
          else return responseread.lectura;
        }
    },
    showcontrol(control) {
      if (this.estadocampos.length > 0) {
        let responsefound = this.estadocampos.find(function (element) {
          if (element.nombre == control) {
            return element;
          }
        });
        if (responsefound == undefined) return false;
        else return responsefound.visible;
      }
    },
    marcarfinalizado() {
      // Estas lineas de codigo se utilizan para generar un temporal del codigo del indicador para que no se muestre
      //================================================
      let ahora = new Date();
      let ahorafilter = new Date();
      ahorafilter.setMinutes(ahorafilter.getMinutes() - this.timewait);
      ahorafilter = new Date(ahorafilter);
      this.AvanceFiltrado.push({
        indicador: this.valPunto.idindicador,
        fecha: ahora
      });
      localStorage.setItem(
        "IndicadorFiltrado",
        JSON.stringify(this.AvanceFiltrado)
      );
      //===================================================
    },
    row_classes(item) {
        if (item.valor != item.metaTmp) {
          return "light-blue";
        } 
    }
  },
  computed: {
    ...mapGetters([
      "gindicador",
      "gmetasvigencia",
      "gmetascuatrenio",
      "gactualizarmetas",
      "gtipoacumulacion",
      "gcampos",
      "gestadometanula",
      "gtienegestion",
      "gmetastemporales"
    ]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    ...mapGetters("usuario", ["gusuario", "gusuarios"]),
    ...mapGetters("carga", ["gerrorcarga"]),
  },
  watch: {
    gindicador: function () {
      this.valPunto = this.gindicador;
    },
    gtienegestion: function () {
      if (this.puedegestionar == false)
        this.puedegestionar = this.gtienegestion;
    },
    valPunto: function () {
      if (this.valPunto != null) {
        this.get_metastemporales({ params: { idindicador: this.valPunto.idindicador}});
      }
    },
    gmetastemporales: function() {
      this.get_metasvigencia({ params: { idindicador: this.valPunto.idindicador}});
      this.metascuatrenio({ params: { idindicador: this.valPunto.idindicador }});
    },
    gmetasvigencia: function () {
      this.MetasVigencia = this.gmetasvigencia;
      if (this.MetasVigencia != undefined) {
        this.estadometasnulas({
          params: {
            idindicador: this.valPunto.idindicador,
          },
        });
      }
      if (this.gestadometanula != undefined)
        if (this.gestadometanula > 0) {
          this.EstadoActualMetas = this.gestadometanula;
          this.get_camposestado({
            params: { idtabla: "Meta", idestado: this.EstadoActualMetas },
          });
        }
    },
    gestadometanula: function () {
      if (this.gestadometanula != undefined) {
        this.EstadoActualMetas = this.gestadometanula;
        this.get_camposestado({
          params: { idtabla: "Meta", idestado: this.EstadoActualMetas },
        });
      }
    },
    gmetascuatrenio: function () {
      this.GetMetasCuatrenio = this.gmetascuatrenio;
    },
    gactualizarmetas: function () {
      if (this.isrefreshmeta == true) {
        
        this.GetMetasCuatrenio = this.gactualizarmetas.metaNavigation.filter(record => { return record.tipoPeriodicidad == "C"; });
        this.MetasVigencia = this.gactualizarmetas.metaNavigation.filter(record => { return record.tipoPeriodicidad == "V";; });
        this.valPunto.meta = this.gactualizarmetas.meta;
        //this.get_metastemporales({ params: { idindicador: this.valPunto.idindicador}});
        //this.get_metasvigencia({ params: { idindicador: this.valPunto.idindicador}});        
        this.isrefreshmeta = false;  
        this.loading = false;      
      }
      
    },
    ginformation: function () {
      
      if (this.loading) {
        if (this.valPunto.finalizar) {
          this.buttonguardarestado = true;
          this.buttonfinalizarestado = true;
          this.buttontext = "aceptar";
          this.timeoutsnak = 0;
          this.snack = true;
          this.MesaggeInfo.mensajeRespuesta =
            "La actualizacion de las metas ha finalizado; presione aceptar para continuar";
          this.MesaggeInfo.color = "infovue";
        } else  {
          this.MesaggeInfo = this.ginformation;
          this.snack = true;
          this.buttonguardarestado = false;
          this.buttonfinalizarestado = false;
          console.log(this.MesaggeInfo.mensajeRespuesta);
          //este console por favor dejarlo, es para que el usuario tenga en consola los posibles mensajes por si no alcanza a leerlo
        }
        this.loading = false;
      }
    },
    gtipoacumulacion: function () {
      this.TAcumulacion = this.gtipoacumulacion;
    },
    gcampos: function () {
      this.estadocampos = this.gcampos;
      if (this.gcampos.length > 0)
        this.MetaSoloLectura = this.readcontrol("valor");
    },
  },
};
</script>
<style>
</style>